"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var ChosenBalls = (function () {
    function ChosenBalls(balls) {
        this.count = 0;
        this.ballNumbers = [];
        this.uniqueNumbers = [];
        this.placeholders = $('.chosen-balls-ticket').children();
        this.balls = balls;
    }
    ChosenBalls.prototype.allColors = function () {
        var self = this;
        this.removeAllBalls();
        var numbers = [
            1, 9, 17, 25, 33, 41,
            2, 10, 18, 26, 34, 42,
            3, 11, 19, 27, 35, 43,
            4, 12, 20, 28, 36, 44,
            5, 13, 21, 29, 37, 45,
            6, 14, 22, 30, 38, 46,
            7, 15, 23, 31, 39, 47,
            8, 16, 24, 32, 40, 48
        ];
        numbers.forEach(function (ballNumber) {
            self.ballNumbers.push(ballNumber);
            var ball = document.getElementById('ball' + ballNumber);
            $(ball).removeClass('clickable-ball');
            $(ball).addClass('ticket-ball-choosen-all');
        });
    };
    ChosenBalls.prototype.getBalls = function () {
        return this.ballNumbers;
    };
    ChosenBalls.prototype.addAllByColor = function (color) {
        var numbers = this.balls.getByColor(color);
        this.addBalls(numbers);
    };
    ChosenBalls.prototype.getRandomNumber = function () {
        var randomNumber = Math.floor((Math.random() * 48) + 1);
        if (this.uniqueNumbers.indexOf(randomNumber) !== -1) {
            return this.getRandomNumber();
        }
        else {
            this.uniqueNumbers.push(randomNumber);
            return randomNumber;
        }
    };
    ChosenBalls.prototype.addRandomSix = function () {
        var ballNumbers = [];
        for (var x = 0; x < 6; x++) {
            ballNumbers.push(this.getRandomNumber());
        }
        this.uniqueNumbers = [];
        this.addBalls(ballNumbers);
    };
    ChosenBalls.prototype.addBalls = function (ballNumbers) {
        var self = this;
        this.removeAllBalls();
        ballNumbers.forEach(function (ballNumber) {
            var ball = document.getElementById('ball' + ballNumber);
            self.add(ball);
        });
    };
    ChosenBalls.prototype.removeAllBalls = function () {
        for (var x = 0; x < this.ballNumbers.length; x++) {
            $('#ball' + this.ballNumbers[x]).removeClass('ticket-ball-choosen')
                .removeClass('ticket-ball-choosen-all')
                .addClass('clickable-ball');
        }
        this.clearPlaceholders();
        this.count = 0;
        this.ballNumbers = [];
    };
    ChosenBalls.prototype.clearPlaceholders = function () {
        for (var x = 0; x < this.count; x++) {
            this.placeholders[x].innerHTML = '';
        }
    };
    ChosenBalls.prototype.add = function (ball) {
        if ($(ball).hasClass('clickable-ball')) {
            if (Object.keys(this.placeholders).length - 2 > this.count) {
                var ballNumber = $(ball).find('div.ticket-ball-number').text();
                this.ballNumbers.push(parseInt(ballNumber));
                var clone = ball.cloneNode(true);
                $(clone).attr('id', 'chosen-' + $(clone).attr('id'));
                $(clone).removeClass('clickable-ball');
                $(this.placeholders[this.count]).append(clone);
                this.count++;
                $(ball).removeClass('clickable-ball');
                $(ball).addClass('ticket-ball-choosen');
            }
            else {
            }
        }
        else { }
    };
    ChosenBalls.prototype.remove = function (ball) {
        if ($(ball).hasClass('ticket-ball-choosen')) {
            var ballNumber = $(ball).find('div.ticket-ball-number').text();
            delete this.ballNumbers[this.ballNumbers.indexOf(parseInt(ballNumber))];
            this.clearPlaceholders();
            this.addBalls(this.ballNumbers);
            $(ball).removeClass('ticket-ball-choosen');
            $(ball).addClass('clickable-ball');
        }
        else { }
    };
    return ChosenBalls;
}());
exports.default = ChosenBalls;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/balls/chosen-balls.ts
// module id = 1166
// module chunks = 2